import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const ORDER_HISTORY_QUERY = gql`
  query OrderHistoryQuery($businessEntityUuid: UUID!) {
    getOrderTasks(businessEntityUuid: $businessEntityUuid) {
      orderUuid
      orderTaskType
      displayName
      orderTaskUuid
      orderItemUuid
      orderTaskStatus
      orderTaskJurisdiction
      createdDatetime
    }
    getPaymentHistory(input: { businessEntityUuid: $businessEntityUuid }) {
      orderItemUuid
      billingItemUuid
      category
      chargeType
      amount
      jurisdiction
      paymentStatus
      paymentDate
      includedItems {
        orderItemUuid
        product
        fee
        status
        jurisdiction
      }
    }
  }
`;

export function useOrderHistory() {
  const { businessEntityUuid } = useBusinessEntity();

  const {
    data, loading, error, refetch
  } = useQuery(ORDER_HISTORY_QUERY, {
    noThrow: true,
    skip: !businessEntityUuid,
    variables: {
      businessEntityUuid
    }
  });

  useError(error);

  return {
    getOrderTasks: data?.getOrderTasks || [],
    getPaymentHistory: data?.getPaymentHistory || [],
    error,
    loading,
    refetch
  };
}
